import Box from '@/components/UI/box/Box';
import Switch from '@/components/UI/switch/Switch';
import { Dispatch, SetStateAction, memo } from 'react';
import styles from './MapSwitch.module.scss';
import Typography from '@/components/UI/typography/Typography';
interface MapSwitchProps {
  isShowMap: boolean;
  setIsShowMap: Dispatch<SetStateAction<boolean>>;
  setMapFullscreen: Dispatch<SetStateAction<boolean>>;
}
const MapSwitch = (props: MapSwitchProps) => {
  return <Box className={styles['map-switch-section']} data-sentry-element="Box" data-sentry-component="MapSwitch" data-sentry-source-file="MapSwitch.tsx">
      <Typography variant="bodyS" data-sentry-element="Typography" data-sentry-source-file="MapSwitch.tsx">نمایش نقشه</Typography>
      <Switch size="small" checked={props.isShowMap} onChange={() => {
      props.setMapFullscreen(false);
      props.setIsShowMap(!props.isShowMap);
    }} data-sentry-element="Switch" data-sentry-source-file="MapSwitch.tsx" />
    </Box>;
};
export default memo(MapSwitch);